export default __webpack_public_path__ + "static/media/check-down-circle.77ef78b6.svg";